<template>
  <div class="mobile_lighting">
    <myHeader />
    <!-- banner模块 -->
    <div class="banner">
      <p style="font-size: 26px; font-weight: 700" class="banner_p">hecoos Lighting</p>
      <p style="font-size: 12px; margin-top: 20px" class="banner_p1">
        集灯光设计编程与灯具控制于一身
      </p>
      <div class="callMe" @click="jumpTo('/CaseDemonstration#CallMe')">联系我们</div>
    </div>

    <!-- 产品模块 -->
    <div class="product">
      <div class="tab">
        <p style="font-weight: 700; font-size: 16px" class="tab_p">概述</p>
        <p style="font-size: 26px; font-weight: 700; margin-top: 12px" class="product_p2">
          核心功能点
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span :class="{ select: currentTabIndex === 0 }" @click="selectTab(0)">
            设计论证
          </span>
          <span :class="{ select: currentTabIndex === 1 }" @click="selectTab(1)">
            精准
          </span>
          <span :class="{ select: currentTabIndex === 2 }" @click="selectTab(2)">
            灵活调整
          </span>
          <span :class="{ select: currentTabIndex === 3 }" @click="selectTab(3)">
            兼容与整合
          </span>
          <div class="underline" :style="{
            width: underlineWidth + 'px',
            left: underlineLeft + 'px',
          }"></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <div class="studio" v-show="showContents[0]">
            <!-- <div style="margin: 0 auto; width: 75%;"> -->
            <img src="https://download.hecoos.com/enlightv/2025-17/2a449aac0ee4d843c961fd582f8ec4dd.png" alt="" />
            <p class="textContent">
              内置“万能灯具”，自主编辑灯库文件并配接地址码，预演各种类灯具效果。
            </p>
            <!-- </div> -->
          </div>
          <div class="studio" v-show="showContents[1]">
            <img src="https://download.hecoos.com/enlightv/2025-17/86c5deb7e08a2f863bacf79d12ebb548.png" alt="" />
            <p class="textContent">
              灯光设计工程对接真实灯具，做“可落地的设计”。
            </p>
          </div>
          <div class="studio" v-show="showContents[2]">
            <img src="https://download.hecoos.com/enlightv/2025-17/ff4a424b3fcffdfd7a618461126526d2.png" alt="" />
            <p class="textContent">快速调整设计方案，无需等到“下一次再汇报”</p>
          </div>
          <div class="studio" v-show="showContents[3]">
            <img src="https://download.hecoos.com/enlightv/2025-17/8f66511803dd8690479fc88f0c8cc3c2.png" alt="" />
            <p class="textContent">
              通过对DMX512、Art-Net等控制协议的整合，hecoos对舞台灯具、影视灯具、LED灯条等灯具的控制尽在掌握。
            </p>
          </div>
        </div>
      </div>
    </div>



    <!-- 应用场景模块 -->
    <div class="application">
      <p style="font-size: 26px; font-weight: 700; margin-bottom: 10px" class="application_p">
        应用场景
      </p>
      <p style="color: #b8b8b8; font-size: 12px; margin-bottom: 10px" class="application_p1">
        hecoos Lighting的实际应用
      </p>

      <!-- <myLightingDesignBanner :applicationInfo="applicationInfo" /> -->
      <sceneBanner :applicationInfo="applicationInfo" />

    </div>
    <myCreativity :imgUrl="imgUrl" />

    <!-- <myListen /> -->
    <myFooter />
  </div>
</template>

<script>
import myHeader from "@/components/mobile/myHeader.vue";
import myFooter from "@/components/mobile/myFooter.vue";
import sceneBanner from "@/components/mobile/scene_banner.vue";
import myCreativity from "@/components/mobile/myCreativity.vue";
// import myListen from "@/components/mobile/myListen.vue";
export default {
  data() {
    return {
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false, false],
      applicationInfo: [
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/4c26cceb192db0e870b3e3f5a6e7f244.png',
          title: "媒体立面",
          msg: "像素级规划建筑立面的每一只灯具，以灯为屏，用灯光呈现动画。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/fa2f7a7824868e8c7944470ce5aeb046.png',
          title: "舞台演出",
          msg: "设计阶段预演规划灯光效果，执行阶段结合时间线精准配合演出节奏，践行“设计即实现”的产品理念。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/573c939ef903eb22889b1ce5f8bbcf73.png',
          title: "艺术装置",
          msg: "多种灯具统一管控，让实现作品创意变得更从容。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/ad08dc41bd6095fde80ba3fcbb180d2d.png',
          title: "虚拟制作",
          msg: "打通实时渲染引擎中的虚拟灯光与拍摄现场的真实灯光控制，深度还原场景氛围。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/e1129dc83d3b32b7781399479293a189.png',
          title: "主题乐园",
          msg: "自动化场景编排，hecoos全天候灯光管理，运维不再难。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/2edfed4893177c6691056fec5d75eb72.png',
          title: "品牌活动",
          msg: "灯光秀预编辑，执行现场仅需微调即可还原设计，大幅减轻现场调试压力。",
        },
      ],
      imgUrl: 'https://download.hecoos.com/enlightv/2025-17/519b1d101bbfe0e2b5f382ad27d8202a.png'
    };
  },
  components: {
    myHeader,
    myFooter,
    sceneBanner,
    myCreativity,
    // myListen,
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
  },
  methods: {
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_xty.scss";
.callMe {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 12px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    @media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }
</style>
